"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pipe4 = exports.pipe3 = void 0;
/**
 * Compose two functions forward
 *
 * ```
 * const addOne      = (x: number) => x + 1;
 * const multiplyTwo = (x: number) => x * 2;
 *
 * const addOneTimesTwo = pipe(
 *   addOne,
 *   multiplyTwo
 * );
 *
 * addOneTimesTwo(2) // => (2 + 1) * 2 = 6
 * ```
 *
 * versus
 *
 * ```
 * multiplyTwo(addOne(2)) // => 6
 * ```
 */
const pipe = (f, g) => (a) => g(f(a));
/**
 * Compose three functions forward
 *
 * ```
 * const addOne      = (x: number) => x + 1;
 * const multiplyTwo = (x: number) => x * 2;
 * const multiplySix = (x: number) => x * 6;
 *
 * const addOneTimesTwoTimesSix = pipe3(
 *   addOne,
 *   multiplyTwo,
 *   multiplySix
 * );
 *
 * addOneTimesTwoTimesSix(2) // => (2 + 1) * 2 * 6 = 36
 *
 * versus
 *
 * ```
 * multiplySix(multiplyTwo(addOne(2))) // => 36
 * ```
 */
const pipe3 = (f, g, h) => (a) => h(g(f(a)));
exports.pipe3 = pipe3;
/**
 * Compose four functions forward
 *
 * ```
 * const addOne      = (x: number) => x + 1;
 * const multiplyTwo = (x: number) => x * 2;
 * const multiplySix = (x: number) => x * 6;
 *
 * const addOneTimesTwoAddOneTimesSix = pipe3(
 *   addOne,
 *   multiplyTwo,
 *   addOne,
 *   multiplySix
 * );
 *
 * addOneTimesTwoAddOneTimesSix(2) // => ((2 + 1) * 2 + 1) * 6 = 42
 * ```
 *
 * versus
 *
 * ```
 * multiplySix(addOne(multiplyTwo(addOne(2)))) // => 42
 * ```
 */
const pipe4 = (f, g, h, i) => (a) => i(h(g(f(a))));
exports.pipe4 = pipe4;
exports.default = pipe;
//# sourceMappingURL=data:application/json;base64,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